import { datadogLogs } from '@datadog/browser-logs';
import { DATADOG_DEFAULT_CONFIG } from '../config';
import type { CreateLoggerParams } from '../types';

let reporter: typeof datadogLogs;

function createReporter(version: string, datadogService: string): typeof datadogLogs {
  datadogLogs.init({
    clientToken: process.env.DATADOG_CLIENT_TOKEN || '',
    site: DATADOG_DEFAULT_CONFIG.site,
    forwardErrorsToLogs: DATADOG_DEFAULT_CONFIG.forwardErrorsToLogs,
    sessionSampleRate: DATADOG_DEFAULT_CONFIG.sessionSampleRate,
    service: datadogService,
    version: version,
  });

  return datadogLogs;
}

const createLogger = ({ version, datadogService, loggerContext, namespace, level }: CreateLoggerParams) => {
  if (!reporter && version && datadogService) {
    reporter = createReporter(version, datadogService);
  }

  reporter.createLogger(namespace, {
    level,
    handler: DATADOG_DEFAULT_CONFIG.handler,
    context: { ...loggerContext, datadogService },
  });

  return reporter.getLogger(namespace);
};

export { createReporter, createLogger };
